module.exports = __webpack_public_path__ + "img/e37701b707ae2cfb2f97ca3b140cf781.png";